import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

interface CustomerSurveyModal {
  isCustomerSurveyModalOpen: boolean;
  setCustomerSurveyModal: (bool: boolean) => void;
}

const initialState: CustomerSurveyModal = {
  isCustomerSurveyModalOpen: false,
  setCustomerSurveyModal: () => {},
};

export const useGetCustomerSurveyModal = create<CustomerSurveyModal>()(
  persist<CustomerSurveyModal>(
    (set) => {
      return {
        ...initialState,

        setCustomerSurveyModal(bool) {
          set((state) => {
            return { ...state, isCustomerSurveyModalOpen: bool };
          });
        },
      };
    },
    {
      name: "customer-survey-modal",
      storage: createJSONStorage(() => localStorage),
    }
  )
);
